import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonDataService } from './../../common-data.service';
import { LocalService } from './../../api/services/local.service';
import { ModalService } from '../../shared/_services/index';
import { ToastsService } from './../../api/toasts/toasts.service';
declare var swal: any;

@Component({
	selector: 'app-areas',
	templateUrl: './areas.component.html',
	styleUrls: ['./areas.component.scss']
})
export class AreasComponent implements OnInit {
	isFormLoading: boolean = false;
	tableSettings: any = {
		columns: [
		// { 
		// 	name: 'Código',
		// 	prop: 'codigo'
		// },
		{ 
			name: 'Nome',
			prop: 'nome'
		},
		{ 
			name: 'Descrição',
			prop: 'descricao'
		}
		],
		temp: [],
		reorderable: true,
		filterrows: [],
		isLoading: true
	}

	pageTitle: any = {
		title: 'Local',
		breadcumbs: [
		{
			title: 'Dashboard',
			href: '/'
		}
		],
		breadcumbActive: 'Local'
	}

	form: FormGroup;
	selected: any = {};
	isCreate: boolean = false;

	constructor(private _commondata: CommonDataService,
							private localService: LocalService, 
							private modalService: ModalService,
							private fb: FormBuilder,
							private toastsService: ToastsService)
	{
		this.form = this.fb.group({  
			nome: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(30)]),
			descricao: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(150)]),
		});
	}

	ngOnInit() {
		this.load();
	}

	load() {
		this.localService.getAreas().subscribe((data: any[]) => {
			this.tableSettings.temp = data;
			this.tableSettings.filterrows = data;
			this.tableSettings.isLoading = false;
			this.isFormLoading = false;
		});
	}

	addNew() {
		this.isCreate = true;
		this.form.reset();
		this.selected = {}
		this.modalService.open('areaModal');
	}

	onSelect(item) {
		this.isCreate = false;
		this.selected = item;
		this.form.reset();
		this.form.patchValue(item);
		this.modalService.open('areaModal');
	}

	onReload() {
		this.tableSettings.isLoading = true;
		this.load();
	}

	updateFilter(val) {
		const temp = this.tableSettings.temp.filter(function (d) {
			return (d.nome.toLowerCase().indexOf(val) !== -1 || 
				d.descricao.toLowerCase().indexOf(val) !== -1 ||
				String(d.codigo).indexOf(val) !== -1 ) 
			|| !val;
		});

		this.tableSettings.filterrows = temp;
	}

	closeModal(id: string) {
		this.modalService.close(id);
	}

	submit() {
		if(this.form.valid) {
			this.isFormLoading = true;
			if(this.isCreate) {
				this.localService.postArea(this.form.value).subscribe((data: any) => {
					this.closeModal('areaModal');
					this.toastsService.toastSuccess("Salvo com sucesso!");
					this.load();
				}, error => {
					this.isFormLoading = false;
					if (typeof error.error === 'string') {
						this.toastsService.toastError(error.error);
					}
					else if (error.error.errors) {
						let errorMessage = ""
						Object.getOwnPropertyNames(error.error.errors).forEach((field) => {
							errorMessage += error.error.errors[field]
						})

						this.toastsService.toastError(errorMessage);
					}
					else {
						this.toastsService.toastError("Revise todos os dados e tente novamente!");
					}
				});
			}
			else {
				this.localService.patchArea(this.form.value, this.selected.codigo).subscribe(() => {
					this.closeModal('areaModal');
					this.toastsService.toastSuccess("Editado com sucesso!");
					this.load();
				}, error => {
					this.isFormLoading = false;
					if (typeof error.error === 'string') {
						this.toastsService.toastError(error.error);
					}
					else if (error.error.errors) {
						let errorMessage = ""
						Object.getOwnPropertyNames(error.error.errors).forEach((field) => {
							errorMessage += error.error.errors[field]
						})

						this.toastsService.toastError(errorMessage);
					}
					else {
						this.toastsService.toastError("Revise todos os dados e tente novamente!");
					}
				});
			}

		}
		else {
			this.validateAllFormFields(this.form);
		}
	}

	deleteArea() {
		swal({
			text: 'Deseja realmente deletar essa Área?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#d33',
			cancelButtonColor: '#3085d6',
			cancelButtonText: 'Não!',
			confirmButtonText: 'Sim, deletar!'
		}).then((result) => {
			if (result.value) {
				this.isFormLoading = true;
				this.localService.deleteArea(this.selected.codigo).subscribe(() => {
					this.closeModal('areaModal');
					this.toastsService.toastSuccess("Deletado com sucesso!");
					this.load();
				}, error => {
					this.isFormLoading = false;
					this.toastsService.toastError("Tente novamente!");
				});
			}
		});
	}

	campoValido(nomeCampo) {
		return !this.form.get(nomeCampo).valid && (this.form.get(nomeCampo).dirty || this.form.get(nomeCampo).touched)
	}

	validateAllFormFields(formGroup: FormGroup) {
		Object.keys(formGroup.controls).forEach(field => { 
			const control = formGroup.get(field);            
			if (control instanceof FormControl) {            
				control.markAsTouched({ onlySelf: true });
			} else if (control instanceof FormGroup) {       
				this.validateAllFormFields(control);           
			}
		});
	}
}
